<template>
  <div class="row">
    <div class="col-5">
      <select
        name="groups"
        ref="avaliableItems"
        class="form-control multiSelect-select"
        multiple size="8 !important"
      >
        <option
          v-for="(item, key) in avaliableItems"
          :value="item[itemValue]"
          :key="key"
          class="multiSelect-option"
        >
          {{ item[itemText] }}
        </option>
      </select>
    </div>

    <div class="col-2">
      <button
        type="button"
        class="btn btn-block"
        @click="() => moveAll('avaliableItems', 'selectedItems')"
      >
        <i class="fas fa-angle-double-right"></i>
      </button>

      <button
        type="button"
        class="btn btn-block"
        @click="() => moveSelected('avaliableItems', 'selectedItems')"
      >
        <i class="fas fa-chevron-right"></i>
      </button>

      <button
        type="button"
        class="btn btn-block"
        @click="() => moveSelected('selectedItems', 'avaliableItems')"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <button
        type="button"
        class="btn btn-block"
        @click="() => moveAll('selectedItems', 'avaliableItems')"
      >
        <i class="fas fa-angle-double-left"></i>
      </button>
    </div>

    <div class="col-5">
      <select
        name="selectedItems"
        id="groups"
        ref="selectedItems"
        class="form-control multiSelect-select"
        multiple size="8 !important"
      >
        <option
          v-for="(item, key) in selectedItems"
          :value="item[itemValue]"
          :key="key"
          class="multiSelect-option"
        >
          {{ item[itemText] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Multiselect',
  data () {
    return {
      avaliableItems: [],
      selectedItems: []
    }
  },
  props: {
    initialSelected: {
      type: Array,
      default: () => []
    },

    items: {
      type: Array,
      required: true
    },

    itemValue: {
      type: String,
      required: true
    },

    itemText: {
      type: String,
      required: true
    }
  },
  methods: {
    moveAll (fromArr, toArr) {
      this[toArr] = [
        ...this[toArr],
        ...this[fromArr]
      ]
      this[fromArr] = []
      this.emitMove()
    },

    moveSelected (fromArr, toArr) {
      for (const option of this.$refs[fromArr].options) {
        if (option.selected) {
          const { value } = option
          const { itemValue } = this
          this[fromArr].forEach((item, key) => {
            if ((item[itemValue] + '') === value) {
              this[fromArr].splice(key, 1)
              this[toArr].push(item)
            }
          })
        }
      }
      this.emitMove()
    },

    emitMove () {
      this.$emit('move', this.selectedItems)
    }
  },
  watch: {
    items: function () {
      this.avaliableItems = this.items
        // cria uma copia para manter o array original
        .slice()
        // filtra os itens que ja devem ser
        // selecionados inicialmente
        .filter(available => {
          return this.initialSelected
            .every(selected => selected.id !== available.id)
        })

      this.selectedItems = this.initialSelected.slice()

      this.emitMove()
    }
  }
}
</script>

<style scoped>
.multiSelect-option {
  font-size: 15px;
}
.multiSelect-select {
  height: 190px !important;
}
</style>
